<template>
  <van-row>
    <van-sticky>
      <van-nav-bar
          title="职位详情"
          left-text="返回"
          left-arrow
          @click-left="onClickLeft"
      />
    </van-sticky>
    <div v-if="is_temp== 0">
      <van-row v-if="show">
      <div class="jobsshowtop">
        <div class="jobsname">{{jobsData.jobs_name}}</div>
        <div class="city">
          <div class="wage">{{jobsData.wage_cn}}</div>
          <!--        <div class="time">-->
          <!--          <span style="color:#FF3300">3天前</span>-->
          <!--        </div>-->
          <!--        <span style="margin: 0 5px;float: right;color: #eeeeee;">|</span>-->
          <div class="district substring">{{jobsData.district_cn}}</div>
          <div class="clear"></div>
        </div>
        <!--      <div class="origin">来源： 总站</div>-->
      </div>
      <div class="jobsshowatt">
        <div class="attul">
          <div class="attli t1" v-if="!isEmptyVal(jobsData.nature_cn)">{{jobsData.nature_cn}}</div>
          <div class="attli t2" v-if="!isEmptyVal(jobsData.sex_cn)">{{jobsData.sex_cn}}</div>
          <div class="attli t3" v-if="jobsData.age === '-' || isEmptyVal(jobsData.age)">年龄不限</div>
          <div class="attli t3" v-else>{{jobsData.age}}</div>
          <div class="attli t4" v-if="isEmptyVal(jobsData.education_cn)">学历不限</div>
          <div class="attli t4" v-else>{{jobsData.education_cn}}</div>
          <div class="attli t5" v-if="isEmptyVal(jobsData.experience_cn)">经验不限</div>
          <div class="attli t5" v-else>{{jobsData.experience_cn}}</div>
          <div class="clear"></div>
        </div>
      </div>
      <div style="width: 100%;height: 10px;background: transparent"></div>
      <div class="describe" v-if="!isEmptyVal(jobsData.jobs_content)">
        <div class="des_head">
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjE2NUFDNDI2RDUyMjExRTk5QjdCQUEzMkE5MUE1NEExIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjE2NUFDNDI3RDUyMjExRTk5QjdCQUEzMkE5MUE1NEExIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MTY1QUM0MjRENTIyMTFFOTlCN0JBQTMyQTkxQTU0QTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MTY1QUM0MjVENTIyMTFFOTlCN0JBQTMyQTkxQTU0QTEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7kp8MjAAABHVBMVEX/nw//2aH/xnH/u1X/rjX/pR//pBv/pR7/rTL/+vP/xGv/zoT/yHb/vFf/oBH/qCX/piH/ng3/4bT/uE3/yXf//fr/58L/3av/6sr/8Nn/xGz/vVv/+fD/5Lz/+/T/8d3/u1b/sDr/7tX/oBL/nQr//Pf/tEP/uU//7dL/+Oz/vl3/6cf/nAf/2Z//79f/mgP/3ar/+vL/sDn/7tT/8+H//v3/z4f/pR3/wWX/mwT/47j/sT3/26X/qSj//fn/683/ynv/zH//yHX/3an/3qz/8dv/4LL/9eX/oxj/xW7/1pj/0Y3/5sD/wGH/7ND/6MX/rTH/1ZX/1Zf/nAj/tkj/mQH/58P/oxr/2J7/wGL/wWP/sj7/8+D/mQD///+ZzcqZAAAAX3RSTlP/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////AJOaXywAAAEdSURBVHjanNPnUsMwEARgpTgOpFfSSeih9x56773vvf9jgANIsnweZthfHu03Ps34LEhL7Sn/MFINHOpnQj0OJPCT5B0H4kBo6oNo+DqWRKRkgsI7xhclPpjBiwE66NMnF1rYd4EmZsmdKKY1cIRdo6cG0hoYypAnge+hXTCBWy+gzIkEOWwx4BQSiA7TU1YBhDhQmlTgkgMLgwokOHAlJLgPc6D4KEFrjQPn6pKbqDMgpQDhxtuXsadAHkWfF/x+TRvHRh/HmQ7KEG1XH8Ore2EugHVVL1WRM3dybAUbwUqvk+AbsMNs9TJk5re5tSdqN3qczNX4/4KPDurWc6Sbpg/Ipi3biTX63xF/g/6UbX1l1R+Eo04q+tmnAAMAkZdSoaXjSgUAAAAASUVORK5CYII=">
          <div class="des_title">职位描述</div>
        </div>
        <div class="des_content">{{jobsData.jobs_content}}</div>
      </div>
      <div style="width: 100%;height: 10px;background: transparent"></div>
      <div class="contact">
        <div class="con_head">
          <img src="data:image/png;base64,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">
          <div class="con_title">联系方式</div>
        </div>
        <div class="con_content">
          <div class="people" v-if="!isEmptyVal(jobsData.job_contact)">联系人: {{jobsData.job_contact}}</div>
          <div class="phone" v-if="!isEmptyVal(jobsData.job_mobile)">电话: {{jobsData.job_mobile}}</div>
          <div class="phone" v-if="!isEmptyVal(jobsData.job_landline_tel) && jobsData.job_landline_tel != '--'">电话: {{jobsData.job_landline_tel}}</div>
          <div class="address" v-if="!isEmptyVal(jobsData.job_address)">地址: {{jobsData.job_address}}</div>
        </div>
        <div class="warn">面试过程中,遇到用人单位收取费用请提高警惕！</div>
      </div>
    </van-row>
    </div>

    <div v-else>
      <van-row v-if="show">
      <div class="jobsshowtop">
        <div class="jobsname">{{jobsData.jobs_name}}</div>
        <div class="city">
          <div class="wage">{{jobsData.wage_cn}}</div>
          <!--        <div class="time">-->
          <!--          <span style="color:#FF3300">3天前</span>-->
          <!--        </div>-->
          <!--        <span style="margin: 0 5px;float: right;color: #eeeeee;">|</span>-->
          <div class="district substring">{{jobsData.district_cn}}</div>
          <div class="clear"></div>
        </div>
        <!--      <div class="origin">来源： 总站</div>-->
      </div>
      <div class="jobsshowatt">
        <div class="attul">
          <div class="attli t5" v-if="isEmptyVal(jobsData.experience_cn)">经验不限</div>
          <div class="attli t5" v-else>{{jobsData.experience_cn}}</div>
          <div class="clear"></div>
        </div>
      </div>
      <div style="width: 100%;height: 10px;background: transparent"></div>
      <div class="describe" v-if="!isEmptyVal(jobsData.desc)">
        <div class="des_head">
          <img src="data:image/png;base64,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">
          <div class="des_title">职位描述</div>
        </div>
        <div class="warn">{{jobsData.jobs_cate_cn}}</div>
        <div class="des_content">{{jobsData.desc}}</div>
      </div>
      <div style="width: 100%;height: 10px;background: transparent"></div>
      <div class="contact">
        <div class="con_head">
          <img src="data:image/png;base64,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">
          <div class="con_title">联系方式</div>
        </div>
        <div class="con_content">
          <div class="people" v-if="!isEmptyVal(jobsData.job_contact)">联系人: {{jobsData.job_contact}}</div>
          <div class="phone" v-if="!isEmptyVal(jobsData.job_mobile)">电话: {{jobsData.job_mobile}}</div>
          <div class="phone" v-if="!isEmptyVal(jobsData.job_landline_tel) && jobsData.job_landline_tel != '--'">电话: {{jobsData.job_landline_tel}}</div>
          <div class="address" v-if="!isEmptyVal(jobsData.job_address)">地址: {{jobsData.job_address}}</div>
        </div>
        <div class="warn">面试过程中,遇到用人单位收取费用请提高警惕！</div>
      </div>
    </van-row>
    </div>

  </van-row>
</template>

<script>
import {isEmpty} from '@/utils/common'
import {mapState} from 'vuex'

export default {
  name: 'JobsView',
  data() {
    return {
      show:false,
      is_temp:0
    }
  },
  computed:{
    ...mapState('common', ['jobsData','jobfairInfo']),
  },
  created() {
    this.$toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration:0,
    })
  },
  mounted() {
    let is_temp = 0;
    if(this.jobfairInfo.jobfair.is_temp){
      is_temp = this.jobfairInfo.jobfair.is_temp
      this.is_temp = is_temp
    }
    this.$store.dispatch('common/jobsDetail',{jobsId:this.$route.query.jobsId,is_temp:is_temp}).then(()=>{
      this.show=true
      this.$toast.clear()
    })
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    isEmptyVal(param) {
      return isEmpty(param)
    }
  }
}
</script>

<style lang="stylus" scoped>
  .p-namecard {
  }
  .m-list {
    padding-top: .3rem;
  }
  .u-bottom {
    margin-bottom: .2rem;
  }
.g-window .m-main, .g-window .m-album, .g-window .m-article, .g-window .m-room{
  padding-top: .5rem;
}
.jobsshowtop{
  background-color: #ffffff;
  position: relative;
  padding: .2rem;
}
.jobsshowtop .jobsname{
  color: #414141;
  font-size: .36rem;
}
.jobsshowtop .city{
  color: #888888;
}
.jobsshowtop .city .wage{
  float: left;
  color: #c9382e;
}
.jobsshowtop .city .time{
  float: right;
  text-align: right;
  color: #8f8f8f;
  font-size: .26rem;
  line-height: .5rem;
}
.jobsshowtop .city .district{
  float: right;
  font-size: .26rem;
  line-height: .5rem;
}
.substring{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.jobsshowtop .clear{
  clear: both;
  height: 0px;
  font-size: 0px;
  line-height: 0px;
}
.jobsshowtop .origin{
  text-align: right;
  color: #999999;
  font-size: .26rem;
}
.jobsshowatt{
  background-color: #ffffff;
  padding-top: .2rem;
  padding-bottom: .2rem;
  border: 1px solid #F2F2F2;
  margin-top: 1px;
}
.jobsshowatt .attul{
  width: 95%;
  margin: 0 auto;
}
.jobsshowatt .attul .attli.t1{
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAbCAYAAABvCO8sAAACkklEQVRIibWWW4iNURTHf+dDUsi8jIZEaJIH15IouRTlwYtyMi8u5VI8rI4aSci1Ruos5Y28mOSFUuTuwRQzUTwg9zFpUopyy8sMWlmfvvmc73LGOau+vrP3WXv/9trf2v+9CuVymRw2C1gBrAVmAIXIkNfAWeCqiNzNmioLuAQ4Asz39k+gC3gH9APjgLnASP//FbBTRC4kTRikwNqB2w7b71EOARYARaAFWCwio4BpQAmYApxX1VuqOiJvhGM8imbgOLAL+JG0KhEZ0FbV3cAh4AswW0TepEVoq3rusOU2XxosYQGHgTnAaPu+qjohDdgBNPq23UiZtw3YlwJ9CEz25v0k4A5PAMvEexmB2PfanOYgIt3AImCsqp6IA4cBxzxJzmXA8KPQk+UkIrZjp4FtqtoUBR7w95ocsGot3IlyFNgKPAE+1pomIv2eG0VVbTDgRAefqkN0oR3198rAP6zZtToCO/w9L3B1MHtWxQSBS1suE5HP7jfJBg4dxIoLMQHPY6bDjQb76s6mk305B38HFpq/qlYCW98vYJ2ItEf6+gz43jvG5zlbbqaXq4Emnzhu4Zb38kdfAwd2G/COOy/zQ5rHLvvzj3gnWLN3PzDyW2+05IQNxrb6mIvhwT/pEdbLtgOdItITAkv+bqs1UFWLnpCbiEjbN9e6Vk+eWppdBldE5DGx66nkWvq0htF1+c9VYV/8Ap4Z3tS+Df8Du25SZo+I/D3fcZXp9RR+4aWF6WxnlSCTypsmY15kDbjxK8naS6DBBddu/kvAHuBRBmiqF1wbgQ8GtKyM+2XVpZbOVgkM9+itzjHwJ1cYW9h0YGnkcO8VkYNJE2YJt9Ui9lglsAVYn+BnybEBOOMXbmUDfgPvC609/9WLEwAAAABJRU5ErkJggg==");
}
.jobsshowatt .attul .attli.t2{
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAYCAYAAADpnJ2CAAADGElEQVRIiZXWa8jeYxwH8M8zzzCncmoaMcr2ZuWc5Mycmi2LFwixnppjfnJaShFvTDwXSTRtRYpiDq1WbBrJ2hLL3iCxEUNOyczCHl09v1u3v/99P/fzfXPd1//63f/v/Tt8v9c9NDo6qoFTcA3OwCH4EW9jOdY3gyPiP/tSygiei4idzdiKKY3983gP12MGfsCBGMnnL2G3thcl2Wosw0e9YroJN+JKPIbp2B+zk7DuH8el2NSDbA0uxHeYVUr5uB/hazgJl9cq4ftGXN3fmoRz8HqDrJb8NNyDHfmu2aWUTaWUoSZhfcECrMCLvUqRWIknMB9HJdmW7PcBqFnOjIj3s//H4Ncm4QP5edEEZB3clutdub6FYyPid5yYP2JGRNTSzs2+/4thXIQtA5JV/IVPsbgOV0QsapxVjBmf4LVY28xwD3w1CcKKT3o8H2us/8OUrPHRkySchV0tz38zntm3/QhXZoOHBySbmnJZ3nJ2hPEeLuj15eo0h2MrXsZlAxAuSyOoVfksDeKh1PCULGtHCq/ixojY1p3hl3gmNTYyAdl1GfNUki3E17gq5VJtcWauNeYSfFNKmdudYefzKsxL8gcz6w6OxP24Gm/ifJyTE7gqIua3/bpSyt753rNwckRs7La2i/FIZlBlUhv/RrrM50n2cJJJsg29yIwPz/aIODtl9I4W874Dx2c5/sR5qIJ+Esd1if3RXM+coAUdnF7lV0q5t0lY8SFuSOKf08Juapj2zViH1iuoJdNapc1oJexgemPt4OCUxrMDZtdB9dmp/Qi3pri3NZ7vk+uOSRJu1xD7UA7GQfgbh2Iv3JelHU4prM74WvIXJkE4p43w9nSRsRyo3bGka78m784NuKVriAZBneb13SXdlffXnpiGE/BLDs20NPl5Gbsk464dhKmUcmf+NVncr4c7M7M/Ws7WpRWuKKWcOgHZBVhapRURm/sZ9n75v2Zf/NRyXn23iv/dUkr10qcj4osuotqaqutqJK9ERJVW3xuiZlh9tnOptuHcNIW7cUUp5YN0qMNyqKqxL42Ieg7+AW0P23ktT7DGAAAAAElFTkSuQmCC");
}
.jobsshowatt .attul .attli.t3{
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAADoUlEQVRIiaWXa6gWZRDHf+oR07KboEWQWJKdpPCDt4iKtNL6YKUmgmmcCMUQ/XsrFS2yUgnqDBoRRXRTw7xUFohFGWKigigqiaIo+kEt1AQz63iJgdnY1ncv72lg392dfWb+z8wzt7dNc3MzFWko8DgwALgb6BhiLcBuYBuwTtLaKurKgNsBc+K6KsU/BOwBLgGNwB2pb38BC4CFklryFLctAHXrfgfmA2eAl4AevlngNmAY8KSkXpKcdyswFfgVeBU4Z2ZP1Wux73h2PDcBH+cpkHQFz8xGhMw1wNuSplex+L0A/R64oQi0YDOrQ3YlMM3MPi0DXghMAD4CHg1Xt4okXZA0yh0AjDWzt/KABwOzwtLnWgtYw3o/9zVh+dCEnz7jcxHFHUp03Qn47gcCfwOfe9RLOl8kZGZnIgU7SLqcWDw3mCNKQJ8G9kbE7wKORCQfN7MuJbJPAO2BV0i5+jXgN+DbAkFX/AWwIVLqoSgmnkZXAz8XoUr6CdifBk78PrNkx8mZDMooPAo8BvQys/tLdHhNcLcPcuDRwVxeIvQwcDDn28a4DyzRsSLukxzYd3kham4RnQh316Ibg3eiSIGnGHASeKBtlL8NJaBO84DrcwLQ4v5NBT0elF0a4mV3BQEPPO88q4BFwNdAJzN7ERgCPC/pdAU9x/wnAe5cQYBIicVRaGal+E2SqpbWP9PAjRWFnCbHdQtwXtLJOmRJ4qEhemu/OgQbA/Q6T0cz+wM4KqnKcRFDRIsDbwbGRLm8WCDgeT4D6Frro5m55c2S3igB7umYHtVfBWNYzsL+wCngTWCHN/+oVm3i6h68ncDrXpPNrGY+m9mD8fhu0iQuR3HomVk7Mnrq4ahw+7LK0oOAmd0F/ADcBAyX9GUG2Mumg7dLavU7wO1A39S6UQG6PkaeK0BrbOIXSTfH8a0xs+Ep0O4B+omkSwnwlLinC0AfYFOqllcmSfcB24FHUjKJ7hdIpZNPi2OBz9z/8XFOvYAZ6//1npm9HNHsRcb7/n8mkKXAMmBipjj8LzKzppg6V0j6MNHVkFH6DHBtzF7dosm3msxsXrTC9ZJGp/VkgYm0cpcr+uyzwNZ6wM2sN/ABcK/rkjQuu6YWMHHem+O8twDfAUtKJhQH9GYx3lMpWBMkvV9rbdlfGHe3B5nX5oS8rR3wOSsYnrPeWj0LEvINz5eU25/zLE7IBT3VHNz7sLvdo/WezLqzwI+AB89aSf6eT8A/01gHsLPHRx4AAAAASUVORK5CYII=");
}
.jobsshowatt .attul .attli.t4{
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAXCAYAAAD6FjQuAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkUzMEIzNkJCMjZENTExRUE5NTE3ODU5NDA3Q0Y5OTgwIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkUzMEIzNkJDMjZENTExRUE5NTE3ODU5NDA3Q0Y5OTgwIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RTMwQjM2QjkyNkQ1MTFFQTk1MTc4NTk0MDdDRjk5ODAiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RTMwQjM2QkEyNkQ1MTFFQTk1MTc4NTk0MDdDRjk5ODAiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz73ybCbAAACpUlEQVR42qyWW4iMYRjHZ5nZnZXs5jCTMbnApli5kSJkywUKN6Ocsmkl4mI3KVqFnHLITNkLh4iVQ1tsLtSWhELElZZcOC1Dw6ptN5YwM36P/p8+0xz2ME/9er95v+97/9/zPv/3aUqi0ahnALEBOqG1vr6+zy8N6afIUvgAJ+Ea3IjFYlOKLTYPXsJ1KIEaWA+L4RmCLTB+sGKz4DHchQpYCSG4A2fABwdgOXQgeBpG91dsKtyHBzAdamEMXMl47jc1a2SshGPKthPBJigvJFYFV6EdZsMWKIXmfOkj2A1bubSszsNm6EVwF/ic50rkxhFwCDZqfjfs6Usxs7kRgTDDKVikqbpwOHzWMlsB3RKKwfC+CuX5gDiYeaY59U0kEr0mdhleyWUN8M1TpECwnYxqAoGAJ5lMlptYG0yEC6pZUSMejy/o6urypNNpj1f72iA3rYFLsB3eD0aEus1nOA7V9tvv9/9zY1SuM2OssjOjLlExAJGZcIvL2zAWlgSDQY/P5/ubmRO/ZIy3cE79zzgCjbqfT6RKzy7T1E8IUrOk/aBm/4k5YdmkYDJsgm1iJxzUPbeItamj6iIW6yCh1jZSDTtnBynVvPVCO6gB1XGffaDqazFMLatDQta2vDjQduWH1ilzL5wts7TGIHzSl61WZvtlpMOud+16LyJfXWuM0pgqJJYp6sQbmWcHnICPliUiPXl6brqQ2FBXgbNFh6sN5YrvTjt0JlKpVM6aWfQM4piFMrbxHtZ/ly2zVquBjkAd3OzHGSuTqay2D+FzJBKxW3PdXT8zZsi6ITnwIrTAc5mmV9ttJpoAc/Rhk/R+M7WszVw0l0GewDhYqLO2VuSLp2oKTQh9yfaAt8ACbcKn/yHVatqVMsFreAGPEEgU2uY/AgwACtHKP+FzXXEAAAAASUVORK5CYII=");
}
.jobsshowatt .attul .attli.t5{
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAXCAYAAAD6FjQuAAACPklEQVRIibXVzavOaRgH8I/jRHMwYhLlyI4ZJQuxYkFCYVKkKCavS93+ADJNCZvzi6WXyIKVsxFNM4lCYoGFhbdSzJAsvL+/TJeuZ3p6ejrnR863fvX8fvd9Xd/n+t7X9b0H9fT0qImCjRiFoXiHpzhaSvm9Toq6ZL1Yin24jY/oQDc24zTmlVI+95WkswbRqiQaj3/brG/DE6zH/r4SddQg685k7YiUUkLKxxjbX6JmGX/F6JSogZDlt5AIqxsxLeuBIziblTWvRzHvcaKU8izI4sD/wmS8bErQSPYqv49pSdS8Jyr7AcPa7BmcDTUrzmwvpmMEXvQnRStKKf3uqarqDvZEmT/j+LcQfQX+xvAge44hA0gU+DGOo6PljAYKXziC7KeWDhwIvI5OD7ILmJ9OMKoG0SRMxZQ6f6qqqpVYhqvR+tGqx7ACb3AJO3GqTeyfmJOyRNwNzCylvG4hmIYtWJjDHqO1pDMD7+I6tmIHTub3E/k7BvZOKrAGl9MAzuOXqqpizmbn+nJ04QHCoNfiVinlbcMbu3PwevOJ901YgD8wMkfjXbpFA/dwJmOjun9wCIdLKZeyynWYqMmIP7RM/v002G35Pi3NeHsa882MnYADOIiLpZRPbaTvTMuq5fqBa/nMyMTv04aulFI21MxRm6yBxRiXcZ9Tttr4WrLAw2+I+YI699l3Q4Osq3GIA4C32a3/yxj3Vbj/onxvd2+1RVVVfS2HDYbbnGsm2425OcSxoTZZP4g8j7AL/gMMi5KWPRlqaAAAAABJRU5ErkJggg==");
}
.jobsshowatt .attul .attli{
  float: left;
  width: 25%;
  height: .6rem;
  line-height:.6rem;
  color: #8f8f8f;
  padding-left: .4rem;
  background-repeat: no-repeat;
  background-position: 0rem center;
  font-size: .26rem;
  background-size: .3rem .3rem;
}
.jobsshowatt .attul .clear{
  clear: both;
  height: 0;
  font-size: 0px;
  line-height: 0px;
}
.company{
  padding: 10px 20px 10px 20px;
  display: flex;
  align-items: center;
  background-color: white;
}
.company .company_left{
  width: 95%;
  display: flex;
  align-items: center;
}
.company .company_left img{
  width: 50px;
  height: 50px;
  border-radius: 50px;
  border: 1px solid black;
}
.company .company_left .company_data{
  margin-left: 20px;
}
.company .company_left .company_data .company_name{
  font-size: 14px;
}
.company .company_left .company_data .company_del{
  font-size: 12px;
  color: #999999;
  padding-top: 5px;
}
.census{
  background-color: #ffffff;
  padding-bottom: 20px;
}
.census .cen_head{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 10px 15px 10px;
  border-bottom: 1px solid #eeeeee;
}
.census .cen_head .cen_left{
  display: flex;
  align-items: center;
}
.census .cen_head .cen_left img{
  width: 20px;
  height: 20px;
}
.census .cen_head .cen_left .title{
  font-size: 14px;
  margin-left: 10px;
}
.census .cen_head .cen_right .login{
  color: #8f8f8f;
  font-size: 12px;
}
.census .cen_content .handle{
  width: 85%;
  margin: 0 auto;
  margin-top: 20px;
  /*border: 1px solid black;*/
  display: flex;
  align-items: center;
}
.census .cen_content .handle_resume{
  width: 50%;
}
.census .cen_content .handle_resume p{
  text-align: center;
}
.census .cen_content .handle_resume p:nth-of-type(1){
  font-size: 14px;
  color: #ff9300;
}
.census .cen_content .handle_resume p:nth-of-type(2){
  margin-top: 10px;
  font-size: 12px;
  color: gray;
}
.describe{
  background-color: #ffffff;
}
.describe .des_head{
  display: flex;
  align-items: center;
  padding: .3rem;
  border-bottom: 1px solid #eeeeee;
}
.describe .des_head img{
  width: .35rem;
  height: .35rem;
}
.describe .des_head .des_title{
  font-size: .32rem;
  margin-left: .1rem;
}
.describe .des_content{
  padding: .2rem .3rem;
}
.contact{
  background-color: #ffffff;
  padding-bottom: .2rem;
}
.contact .con_head{
  display: flex;
  align-items: center;
  padding: 15px 10px 15px 10px;
  border-bottom: 1px solid #eeeeee;
}
.contact .con_head img{
  width: .35rem;
  height: .35rem;
}
.contact .con_head .con_title{
  font-size: .32rem;
  margin-left: .1rem;
}
.con_content{
  padding: .2rem .3rem;
  font-size: .3rem;
  line-height: .5rem;
  margin-bottom: .2rem;
}
.warn{
  width: 90%;
  margin: 0 auto;
  background-color: #FFFFE9;
  border: 1px solid #F3EAC3;
  border-radius: 5px;
  color: #F26B01;
  text-align: center;
  font-size: .28rem;
  line-height: .7rem;
  height: .7rem;
}
</style>
